import Api from '../../api'
import { call, put, takeLatest } from 'redux-saga/effects'
import { LOGOUT } from 'portal-modules/auth/redux/modules/user'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'

// action types
export const REQUEST_USAGE = 'rp/utilities/REQUEST_USAGE'
export const RECEIVE_USAGE = 'rp/utilities/RECEIVE_USAGE'
export const REQUEST_INVOICES = 'rp/utilities/REQUEST_INVOICES'
export const RECEIVE_INVOICES = 'rp/utilities/RECEIVE_INVOICES'
export const REQUEST_INVOICE_DETAILS = 'rp/utilities/REQUEST_INVOICE_DETAILS'
export const RECEIVE_INVOICE_DETAILS = 'rp/utilities/RECEIVE_INVOICE_DETAILS'

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case RECEIVE_INVOICES:
    case RECEIVE_USAGE:
      return { ...state, ...payload }
    case RECEIVE_INVOICE_DETAILS:
      return {
        ...state,
        detailedInvoices: { ...state.detailedInvoices, ...payload },
      }
    case LOGOUT:
      return {}
    default:
      return state
  }
}

// action creators
export const requestUsage = () => ({
  type: REQUEST_USAGE,
})

export const receiveUsage = payload => ({
  type: RECEIVE_USAGE,
  payload,
})

export const requestInvoices = () => ({
  type: REQUEST_INVOICES,
})

export const receiveInvoices = payload => ({
  type: RECEIVE_INVOICES,
  payload,
})

export const requestInvoiceDetails = payload => ({
  type: REQUEST_INVOICE_DETAILS,
  payload,
})

export const receiveInvoiceDetails = payload => ({
  type: RECEIVE_INVOICE_DETAILS,
  payload,
})

// sagas
export function* fetchUsage() {
  const data = yield call(Api.getUsage)
  yield put(
    receiveUsage({
      usage: data
        ? Object.values(data).reduce((arr, dataItem) => {
            const {
              meter_transmission_batch_id,
              property_average,
              utility_consumption_type_name,
              utility_name,
              ...rest
            } = dataItem
            return [
              ...arr,
              {
                meter_transmission_batch_id,
                my_usage: rest,
                property_average,
                utility_consumption_type_name,
                utility_name,
              },
            ]
          }, [])
        : [],
    }),
  )
}

export function* watchRequestUsage() {
  yield takeLatest(
    REQUEST_USAGE,
    createRequestSaga(fetchUsage, {
      key: 'utilities',
      message: __('Checking for usage reports'),
    }),
  )
}

export function* fetchInvoices() {
  const { invoices } = yield call(Api.getInvoices)
  yield put(receiveInvoices({ invoices }))
}

export function* watchRequestInvoices() {
  yield takeLatest(
    REQUEST_INVOICES,
    createRequestSaga(fetchInvoices, {
      key: 'utilities',
      message: __('Checking for invoices'),
    }),
  )
}

export function* fetchInvoiceDetails({ payload }) {
  const data = yield call(Api.getInvoice, { invoice_id: payload })
  yield put(
    receiveInvoiceDetails({
      [payload]: {
        ...data,
        utility_data: data.utility_data ? Object.values(data.utility_data) : [],
      },
    }),
  )
}

export function* watchRequestInvoiceDetails() {
  yield takeLatest(
    REQUEST_INVOICE_DETAILS,
    createRequestSaga(fetchInvoiceDetails, {
      key: 'utilities',
      message: __('Receiving details'),
    }),
  )
}

export const sagas = [
  watchRequestInvoiceDetails,
  watchRequestInvoices,
  watchRequestUsage,
]
